import { grabEmployeeRoles, grabEmployees, grabAdminEmployees, createEmployeeRole, changeEmployeeRole, updateEmployeeData, changeEmployeeAssignedRole, changeEmployeeCanAddDriveTime, changeEmployeeCompanyPhone, changeEmployeeCanCreateWorkOrders, changeEmployeeActive } from "../dataLayer/employee";
import { EmployeeInfo, RoleInfo, RoleWriteInput, AdminEmployeeInfo } from "../interfaces/EmployeeInfoInterface";

class EmployeeViewManager {

    async getEmployees(): Promise<EmployeeInfo[]> {

        const response = await grabEmployees();

        const data : EmployeeInfo[] = response.data;

        return data;

    }
  
    async getEmployeeRoles(): Promise<RoleInfo[]> {

        const response = await grabEmployeeRoles();

        const data : RoleInfo[] = response.data;

        return data;

    }

    /** POST /admin/roles. Returns the created role (throws on any failure). */
    async addEmployeeRole(newRole: RoleWriteInput): Promise<RoleInfo | undefined> {

        return await createEmployeeRole(newRole);

    }

    /** PUT /admin/roles/:id. Throws on any failure, including a 200 {success:false}. */
    async editEmployeeRole(roleID: number, updatedRole: RoleWriteInput): Promise<void> {

        await changeEmployeeRole(roleID, updatedRole);

    }
  
  async getAdminEmployees(): Promise<AdminEmployeeInfo[]> {

        const response = await grabAdminEmployees();

        const data : AdminEmployeeInfo[] = response.data;

        return data;

    }

    async syncEmployeeData(altID: String, altLocationID: String): Promise<any> {

        const response = await updateEmployeeData(altID, altLocationID);

        return response;

    }

  async updateEmployeeRole(employeeID: number, roleID: number): Promise<any> {

        const response = await changeEmployeeAssignedRole(employeeID, roleID);

        return response;

    }

  async updateEmployeeCanAddDriveTime(employeeID: number, canAddDriveTime: boolean): Promise<any> {

        const response = await changeEmployeeCanAddDriveTime(employeeID, canAddDriveTime);

        return response;

    }

  async updateEmployeeCompanyPhone(employeeID: number, hasCompanyPhone: boolean, startDate?: string): Promise<any> {

        const response = await changeEmployeeCompanyPhone(employeeID, hasCompanyPhone, startDate);

        return response;

    }

  async updateEmployeeActive(employeeID: number, active: boolean): Promise<any> {

        const response = await changeEmployeeActive(employeeID, active);

        return response;

    }

  async updateEmployeeCanCreateWorkOrders(employeeID: number, canCreateWorkOrders: boolean): Promise<any> {

        const response = await changeEmployeeCanCreateWorkOrders(employeeID, canCreateWorkOrders);

        return response;

    }

}

export default new EmployeeViewManager();